import React, { useState } from "react";
import './header.css';
import { Link } from 'react-router-dom';
import { HiOutlineHome, HiOutlineUser, HiOutlineBadgeCheck, HiOutlineClipboardList, HiOutlinePhotograph, HiOutlineMail, HiX, HiOutlineMenu } from "react-icons/hi";
import HomeMaxRoundedIcon from '@mui/icons-material/HomeMaxRounded';
import ScienceRoundedIcon from '@mui/icons-material/ScienceRounded';
import DownhillSkiingRoundedIcon from '@mui/icons-material/DownhillSkiingRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import ElectricalServicesRoundedIcon from '@mui/icons-material/ElectricalServicesRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import BookRoundedIcon from '@mui/icons-material/BookRounded';
import PermPhoneMsgRoundedIcon from '@mui/icons-material/PermPhoneMsgRounded';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveNav } from '../../redux/actions';
import logo from '../../assets/logo.png';
import AutoSuggestSearch from "./AutoSuggestSearch";

const Header = () => {
    window.addEventListener("scroll", function () {
        const header = document.querySelector(".header");
        if (this.scrollY >= 80) header.classList.add("scroll-header");
        else header.classList.remove("scroll-header");
    });


    const [Toggle, showMenu] = useState(false);
    // const [activeNav, setActiveNav] = useState("#home");
    const dispatch = useDispatch();
    const activeNav = useSelector((state) => state.navigation.activeNav);

    return (
        <header className="header">
            <nav className="nav container">
                <Link
                    to="/"
                    className="nav__logo"
                    style={{ fontSize: "x-large", letterSpacing: "1px", display: "flex", alignItems: "center", gap: "8px" }}
                    onClick={() => dispatch(setActiveNav('#home'))}
                >
                    <svg width="33" height="44" viewBox="0 0 33 44" fill="none" xmlns="http://www.w3.org/2000/svg" id="logo"><path d="M17.1026 0.0502575H1.49434C1.19446 0.0502575 0.906859 0.16938 0.694815 0.381425C0.48277 0.59347 0.363647 0.881056 0.363647 1.18093V28.9189C0.367464 32.8948 1.94793 36.707 4.75845 39.5193C7.56897 42.3316 11.3801 43.9145 15.3561 43.9209C15.5045 43.9209 15.6516 43.8917 15.7887 43.8348C15.9259 43.778 16.0506 43.6947 16.1556 43.5897C16.2606 43.4847 16.3438 43.3601 16.4007 43.2229C16.4575 43.0857 16.4867 42.9387 16.4867 42.7902V30.0495H17.093C19.0854 30.0852 21.0649 29.7236 22.916 28.9858C24.7671 28.2481 26.4526 27.1489 27.8742 25.7525C29.2959 24.3561 30.425 22.6905 31.1959 20.8529C31.9667 19.0153 32.3637 17.0426 32.3637 15.0499C32.3637 13.0572 31.9667 11.0845 31.1959 9.24687C30.425 7.40928 29.2959 5.74366 27.8742 4.34728C26.4526 2.95089 24.7671 1.85173 22.916 1.11395C21.0649 0.376168 19.0854 0.0145723 17.093 0.0502575H17.1026ZM14.2157 41.6114C11.2443 41.3412 8.46159 40.0378 6.35178 37.928C4.24197 35.8181 2.93856 33.0354 2.66832 30.064H14.2157V41.6114ZM14.2157 24.1315L3.32749 2.31161H14.235L14.2157 24.1315ZM17.1026 27.7882H16.4964V2.31161H17.1026C18.7962 2.27869 20.4794 2.58386 22.0537 3.20923C23.628 3.8346 25.0618 4.76763 26.2712 5.95375C27.4806 7.13987 28.4413 8.55527 29.0972 10.1171C29.753 11.679 30.0908 13.3559 30.0908 15.0499C30.0908 16.7439 29.753 18.4208 29.0972 19.9827C28.4413 21.5445 27.4806 22.9599 26.2712 24.146C25.0618 25.3321 23.628 26.2652 22.0537 26.8906C20.4794 27.5159 18.7962 27.8211 17.1026 27.7882Z" fill="currentColor"></path></svg>
                    <h1 style={{ margin: '-8px' }}>ortfolio</h1>
                </Link>

                <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>

                    <ul className="nav__list grid">
                        <li className="nav__item">
                            <Link
                                to={'/'}
                                onClick={() => dispatch(setActiveNav('#home'))}
                                className={activeNav === "#home" ? "nav__link active-link" : "nav__link"}>
                                {/* <HiOutlineHome className="nav__icon" /> */}
                                <HomeMaxRoundedIcon /> Home
                            </Link>
                        </li>
                        <li className="nav__item">
                            <Link
                                to={'/about'}
                                onClick={() => dispatch(setActiveNav('#about'))}
                                className={activeNav === "#about" ? "nav__link active-link" : "nav__link"}>
                                {/* <HiOutlineUser className="nav__icon" /> */}
                                <ScienceRoundedIcon /> About
                            </Link>
                        </li>
                        <li className="nav__item">
                            <Link
                                to={'/skills'}
                                onClick={() => dispatch(setActiveNav('#skills'))}
                                className={activeNav === "#skills" ? "nav__link active-link" : "nav__link"}>
                                {/* <HiOutlineBadgeCheck className="nav__icon" /> */}
                                <DownhillSkiingRoundedIcon /> Skills
                            </Link>
                        </li>
                        <li className="nav__item">
                            <Link
                                to={'/qualification'}
                                onClick={() => dispatch(setActiveNav('#qualification'))}
                                className={activeNav === "#qualification" ? "nav__link active-link" : "nav__link"}>
                                {/* <HiOutlineBadgeCheck className="nav__icon" /> */}
                                <SchoolRoundedIcon /> Qualification
                            </Link>
                        </li>
                        <li className="nav__item">
                            <Link
                                to={'/services'}
                                onClick={() => dispatch(setActiveNav('#services'))}
                                className={activeNav === "#services" ? "nav__link active-link" : "nav__link"}>
                                {/* <HiOutlineClipboardList className="nav__icon" /> */}
                                <ElectricalServicesRoundedIcon /> Services
                            </Link>
                        </li>
                        <li className="nav__item">
                            <Link
                                to={'/projects'}
                                onClick={() => dispatch(setActiveNav('#projects'))}
                                className={activeNav === "#projects" ? "nav__link active-link" : "nav__link"}>
                                {/* <HiOutlinePhotograph className="nav__icon" /> */}
                                <DashboardRoundedIcon />Projects
                            </Link>
                        </li>
                        <li className="nav__item">
                            <Link
                                to={'https://clubofdevelopers.blogspot.com/search'}
                                target="_blank"
                                onClick={() => dispatch(setActiveNav('#blog'))}
                                className={activeNav === "#blog" ? "nav__link active-link" : "nav__link"}>
                                {/* <HiOutlineMail className="nav__icon" /> */}
                                <BookRoundedIcon /> Blog
                            </Link>
                        </li>
                        <li className="nav__item">
                            <Link
                                to={'/contact'}
                                onClick={() => dispatch(setActiveNav('#contact'))}
                                className={activeNav === "#contact" ? "nav__link active-link" : "nav__link"}>
                                {/* <HiOutlineMail className="nav__icon" /> */}
                                <PermPhoneMsgRoundedIcon /> Contact
                            </Link>
                        </li>
                        <li className="nav__item">
                            <AutoSuggestSearch />
                        </li>
                    </ul>
                    <HiX className="nav__close" onClick={() => showMenu(!Toggle)} />
                </div>
                <div className="nav__toggle" onClick={() => showMenu(!Toggle)}>
                    <HiOutlineMenu />
                </div>
            </nav>
        </header >
    )
}

export default Header